import React, { useState, useEffect } from 'react';

export default function AskSomethingElse() {
  const [isMobile, setIsMobile] = useState(false);
  const [requestData, setRequestData] = useState({
    name: '',
    phone: '',
    email: '',
    itemName: '',
    specifications: '',
    transmissionChannel: 'whatsapp' // default submission route
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRequestData(prev => ({ ...prev, [name]: value }));
  };

  // --- SUBMISSION LOGIC DISPATCHERS ---
  const handleRequestSubmit = (e) => {
    e.preventDefault();
    
    if (!requestData.name || !requestData.phone || !requestData.itemName || !requestData.specifications) {
      alert("Please populate all required fields marked with *");
      return;
    }

    const WHATSAPP_NUMBER = "919016235501";
    const BUSINESS_EMAIL = "shabaaztradingco04@gmail.com";

    // Text Template Generation
    const formattedMessage = (
      `*CUSTOM COMPONENT SOURCING REQUEST*\n` +
      `*Shabaaz Trading Co. Procurement Desk*\n\n` +
      `• *Client Name:* ${requestData.name}\n` +
      `• *Phone Number:* ${requestData.phone}\n` +
      `• *Corporate Email:* ${requestData.email || 'Not Provided'}\n\n` +
      `*SYSTEM REQUIREMENTS MATERIAL:*\n` +
      `• *Target Item Name:* ${requestData.itemName}\n` +
      `• *Technical Specifications / Custom Needs:*\n${requestData.specifications}`
    );

    if (requestData.transmissionChannel === 'whatsapp') {
      window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(formattedMessage)}`, '_blank');
    } else if (requestData.transmissionChannel === 'email_native') {
      const subject = encodeURIComponent(`Custom Sourcing Request: ${requestData.itemName}`);
      window.open(`mailto:${BUSINESS_EMAIL}?subject=${subject}&body=${encodeURIComponent(formattedMessage.replace(/\*/g, ''))}`, '_self');
    } else {
      const subject = encodeURIComponent(`Custom Sourcing Request: ${requestData.itemName}`);
      window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${BUSINESS_EMAIL}&su=${subject}&body=${encodeURIComponent(formattedMessage.replace(/\*/g, ''))}`, '_blank');
    }
  };

  return (
    <div style={{ maxWidth: '1280px', margin: '0 auto', padding: isMobile ? '40px 20px' : '80px 40px', fontFamily: '"Inter", sans-serif', boxSizing: 'border-box' }}>
      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '50px', alignItems: 'stretch' }}>
        
        {/* Left Side Content - Context and Brand Value Banner */}
        <div style={{ flex: '1', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <span style={{ fontSize: '0.85rem', fontWeight: '700', color: '#0284c7', textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '12px' }}>Custom Procurement</span>
          <h2 style={{ fontSize: isMobile ? '2rem' : '2.75rem', fontWeight: '800', letterSpacing: '-0.03em', color: '#0f172a', margin: '0 0 20px 0', lineHeight: '1.2' }}>
            Can’t Find What You Are Looking For?
          </h2>
          <p style={{ fontSize: '1.05rem', color: '#475569', lineHeight: '1.7', margin: '0 0 30px 0' }}>
            Our expansive global industrial network goes far beyond our active digital inventory listings. Fill out this technical blueprint router spec sheet, choose your preferred secure line, and dispatch it directly to our global export desks.
          </p>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
              <div style={{ fontSize: '1.2rem', color: '#16a34a', backgroundColor: '#f0fdf4', padding: '10px', borderRadius: '50%' }}>✓</div>
              <span style={{ fontWeight: '600', color: '#334155', fontSize: '0.95rem' }}>Global structural containerized sourcing protocols.</span>
            </div>
            <div style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
              <div style={{ fontSize: '1.2rem', color: '#0284c7', backgroundColor: '#eff6ff', padding: '10px', borderRadius: '50%' }}>✓</div>
              <span style={{ fontWeight: '600', color: '#334155', fontSize: '0.95rem' }}>Vetted compliance verification on rare industrial units.</span>
            </div>
          </div>
        </div>

        {/* Right Side - Interactive Premium Sourcing Form */}
        <div style={{ flex: '1.2', backgroundColor: '#ffffff', border: '1px solid #e2e8f0', padding: isMobile ? '24px' : '40px', borderRadius: '20px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.02), 0 10px 10px -5px rgba(0,0,0,0.01)' }}>
          <form onSubmit={handleRequestSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
            
            <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '14px' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '6px', color: '#334155' }}>Your Full Name *</label>
                <input type="text" name="name" value={requestData.name} onChange={handleChange} required placeholder="Enter your complete name" style={{ width: '100%', padding: '12px 16px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '6px', color: '#334155' }}>Phone Number *</label>
                <input type="tel" name="phone" value={requestData.phone} onChange={handleChange} required placeholder="Include Country Code" style={{ width: '100%', padding: '12px 16px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }} />
              </div>
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '6px', color: '#334155' }}>Corporate Email Address (Optional)</label>
              <input type="email" name="email" value={requestData.email} onChange={handleChange} placeholder="name@company.com" style={{ width: '100%', padding: '12px 16px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }} />
            </div>

            <div style={{ height: '1px', backgroundColor: '#f1f5f9', margin: '6px 0' }} />

            <div>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '6px', color: '#334155' }}>Required Item/Hardware Name *</label>
              <input type="text" name="itemName" value={requestData.itemName} onChange={handleChange} required placeholder="e.g., High-Pressure Valve Module, Structural Beams" style={{ width: '100%', padding: '12px 16px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }} />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '6px', color: '#334155' }}>Technical Specifications / Requirements *</label>
              <textarea name="specifications" rows="4" value={requestData.specifications} onChange={handleChange} required placeholder="Describe measurements, material types, target timeline standards, quantities required, etc..." style={{ width: '100%', padding: '14px 16px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.9rem', outline: 'none', resize: 'none', boxSizing: 'border-box', lineHeight: '1.5' }} />
            </div>

            {/* Premium Radio Selection Cluster for Route Telemetry */}
            <div>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '10px', color: '#334155' }}>Select Submission Route</label>
              <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '10px' }}>
                
                <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', borderRadius: '8px', border: requestData.transmissionChannel === 'whatsapp' ? '2px solid #25D366' : '1px solid #cbd5e1', backgroundColor: requestData.transmissionChannel === 'whatsapp' ? '#f0fdf4' : 'transparent', cursor: 'pointer', transition: 'all 0.2s' }}>
                  <input type="radio" name="transmissionChannel" value="whatsapp" checked={requestData.transmissionChannel === 'whatsapp'} onChange={handleChange} style={{ accentColor: '#25D366' }} />
                  <span style={{ fontSize: '0.85rem', fontWeight: '600', color: '#1e293b' }}>💬 WhatsApp Line</span>
                </label>

                <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', borderRadius: '8px', border: requestData.transmissionChannel === 'email_native' ? '2px solid #0284c7' : '1px solid #cbd5e1', backgroundColor: requestData.transmissionChannel === 'email_native' ? '#f0f9ff' : 'transparent', cursor: 'pointer', transition: 'all 0.2s' }}>
                  <input type="radio" name="transmissionChannel" value="email_native" checked={requestData.transmissionChannel === 'email_native'} onChange={handleChange} style={{ accentColor: '#0284c7' }} />
                  <span style={{ fontSize: '0.85rem', fontWeight: '600', color: '#1e293b' }}>📬 Native Mail App</span>
                </label>

                <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', borderRadius: '8px', border: requestData.transmissionChannel === 'email_gmail' ? '2px solid #ea4335' : '1px solid #cbd5e1', backgroundColor: requestData.transmissionChannel === 'email_gmail' ? '#fef2f2' : 'transparent', cursor: 'pointer', transition: 'all 0.2s' }}>
                  <input type="radio" name="transmissionChannel" value="email_gmail" checked={requestData.transmissionChannel === 'email_gmail'} onChange={handleChange} style={{ accentColor: '#ea4335' }} />
                  <span style={{ fontSize: '0.85rem', fontWeight: '600', color: '#1e293b' }}>🌐 Browser Gmail</span>
                </label>

              </div>
            </div>

            <button type="submit" style={{ width: '100%', padding: '14px', backgroundColor: requestData.transmissionChannel === 'whatsapp' ? '#25D366' : requestData.transmissionChannel === 'email_native' ? '#0284c7' : '#ea4335', color: '#ffffff', border: 'none', borderRadius: '8px', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer', transition: 'all 0.3s', marginTop: '6px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
              Dispatch Sourcing Transmission
            </button>
            
          </form>
        </div>

      </div>
    </div>
  );
}